import moment from "moment/moment";

export const handleDateFormat = (sDate, dateFormat = "YYYY-MM-DD") => {
  const date = moment(sDate);
  return date.format(dateFormat);

  //   sDate = new Date(sDate);
  //   const month = String(sDate.getMonth() + 1).padStart(2, "0");
  //   const day = String(sDate.getDate()).padStart(2, "0");
  //   const year = sDate.getFullYear();
  //   return `${year}-${month}`;
  //   return `${year}-${month}-${day}`;
  // return `${month}-${day}-${year}`
};

export const getStartDateOfMonth = (date, returnFormat = "YYYY-MM-DD") => {
  if (!date) {
    return date;
  }
  const momentDate = moment(date, "YYYY-MM", true);
  return momentDate.startOf("month").format(returnFormat);
};

export const getEndDateOfMonth = (date, returnFormat = "YYYY-MM-DD") => {
  if (!date) {
    return date;
  }
  const momentDate = moment(date, "YYYY-MM", true);
  return momentDate.endOf("month").format(returnFormat);
};
